module.exports = __webpack_public_path__ + "img/1920_news_main_img4.85df22e1.png";